module.exports = __webpack_public_path__ + "static/media/york-16.06a17bbd.jpg";